import {FormGroup} from '@angular/forms';
import {Component, forwardRef, Inject, Input} from '@angular/core';
import {FilterFieldAbstract} from './filter-field.abstract';
import {FilterDirective} from './container/filter.directive';

@Component({
    selector: 'tfl-filter-field-input',
    template: `
        <div [formGroup]="formGroup"
             [ngClass]="getFormGroupClasses()">

            <label [for]="id"
                   [ngClass]="getFormLabelClasses()">
                {{ label | translate }}:
            </label>

            <div [ngClass]="getFormControlClasses()">
                <input [id]="id"
                       [name]="id"
                       [type]="type"
                       class="form-control"
                       [formControlName]="controlName"
                       placeholder="{{ placeholder | translate }}"/>
            </div>
        </div>
    `
})
export class FilterFieldInputComponent extends FilterFieldAbstract {

    @Input('id') id: string;
    @Input('type') type: string = 'text';
    @Input('label') label: string;
    @Input('placeholder') placeholder: string;

    @Input('formGroup') formGroup: FormGroup;
    @Input('controlName') controlName: string;
    @Input('defValue') defValue: string;

    protected filter: FilterDirective;

    constructor(@Inject(forwardRef(() => FilterDirective)) filter: FilterDirective) {
        super();
        this.filter = filter;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/filter-field-input.component.ts